import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SidebarStimulus;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { IconTextLeftLine } from '@instructure/ui-icons';
import { jsx } from '@instructure/emotion';
import { Link } from '@instructure/ui-link';
import Collection from './Collection';
import Title from './Title';
import Summary from './Summary';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { Flex, END_EDITING_TRIGGER_CLASSNAME, withStyleOverrides } from '@instructure/quiz-common';
import { Tooltip } from '@instructure/ui-tooltip';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { View } from '@instructure/ui-view';
import { Text } from '@instructure/ui-text';
export var DISPLAY_AS_SUMMARY_LIMIT = 5;
export var SidebarStimulus = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_SidebarStimulus = /*#__PURE__*/function (_Component) {
  function SidebarStimulus() {
    var _this2;
    _classCallCheck(this, SidebarStimulus);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, SidebarStimulus, [].concat(args));
    _defineProperty(_this2, "scrollToItem", function (e) {
      e.preventDefault(); // prevent default link navigation
      // this can be a real scroll or a oqaat change
      // depending on whether is is oqaat or not
      _this2.props.scrollToItem(_this2.props.stimulusParent.id);
      e.stopPropagation();
    });
    return _this2;
  }
  _inherits(SidebarStimulus, _Component);
  return _createClass(SidebarStimulus, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "stimulusIsPassage",
    value: function stimulusIsPassage() {
      var _this$props$stimulus;
      return (_this$props$stimulus = this.props.stimulus) === null || _this$props$stimulus === void 0 ? void 0 : _this$props$stimulus.isPassage;
    }
  }, {
    key: "renderCollection",
    value: function renderCollection() {
      var _this$props$stimulus2;
      var _this$props = this.props,
        displayPosition = _this$props.displayPosition,
        isOver = _this$props.isOver,
        isShowingItems = _this$props.isShowingItems,
        renderSidebarItem = _this$props.renderSidebarItem,
        sidebarOpen = _this$props.sidebarOpen,
        isDragging = _this$props.isDragging;
      if (this.stimulusIsPassage() || isDragging) {
        return null;
      }
      return jsx(Collection, {
        firstPosition: displayPosition,
        isOver: isOver,
        isShowingItems: isShowingItems,
        itemCollection: this.props.childEntries,
        renderSidebarItem: renderSidebarItem,
        sidebarOpen: sidebarOpen,
        stimulusId: this.props.stimulus.id,
        isPassage: (_this$props$stimulus2 = this.props.stimulus) === null || _this$props$stimulus2 === void 0 ? void 0 : _this$props$stimulus2.isPassage
      });
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this$props2 = this.props,
        displayPosition = _this$props2.displayPosition,
        sidebarOpen = _this$props2.sidebarOpen;
      var textForNavigation;
      if (this.stimulusIsPassage()) {
        textForNavigation = t('Navigate to text block');
      } else {
        textForNavigation = t('Navigate to stimulus at position {displayPosition}', {
          displayPosition: displayPosition
        });
      }
      var content = sidebarOpen ? '' : textForNavigation;
      var tip = jsx(Text, {
        "aria-hidden": !sidebarOpen,
        "aria-label": content
      }, content);
      return jsx(Tooltip, {
        renderTip: tip,
        placement: "start",
        on: sidebarOpen ? [] : ['hover', 'focus']
      }, jsx(Link, {
        href: "#",
        margin: "small",
        forceButtonRole: false,
        onClick: this.scrollToItem,
        renderIcon: jsx(IconTextLeftLine, {
          color: "primary"
        }),
        className: END_EDITING_TRIGGER_CLASSNAME
      }, jsx(ScreenReaderContent, null, textForNavigation)));
    }
  }, {
    key: "infoHeaderLabel",
    value: function infoHeaderLabel() {
      return this.stimulusIsPassage() ? t('Text Block') : t('Stimulus');
    }
  }, {
    key: "renderSummary",
    value: function renderSummary() {
      var _this$props3 = this.props,
        displayPosition = _this$props3.displayPosition,
        isDragging = _this$props3.isDragging,
        isShowingItems = _this$props3.isShowingItems,
        sidebarOpen = _this$props3.sidebarOpen,
        stimulus = _this$props3.stimulus;
      if (this.stimulusIsPassage()) {
        return null;
      }
      return jsx(Summary, {
        startPosition: displayPosition,
        isDragging: isDragging,
        isShowingItems: isShowingItems,
        stimulusId: stimulus.id,
        sidebarOpen: sidebarOpen,
        numberOfItems: this.props.childEntries.size
      });
    }
  }, {
    key: "stimulusHoverCss",
    value: function stimulusHoverCss() {
      return {
        // TODO: figure out how to get rid of the last of these styles.
        ':hover': this.props.styles.onHover
      };
    }
  }, {
    key: "renderClosed",
    value: function renderClosed() {
      return jsx(View, {
        borderWidth: "0 0 small 0",
        borderColor: "primary",
        as: "div"
      }, jsx(View, {
        textAlign: "center",
        padding: "xx-small 0",
        borderWidth: "none large none none",
        borderColor: "transparent",
        css: this.stimulusHoverCss(),
        as: "div"
      }, this.renderButton()), this.renderCollection());
    }
  }, {
    key: "renderOpen",
    value: function renderOpen() {
      var _this$props4 = this.props,
        stimulus = _this$props4.stimulus,
        children = _this$props4.children;
      return jsx(View, {
        borderWidth: "0 0 small 0",
        borderColor: "primary",
        as: "div"
      }, jsx(View, {
        padding: "small 0",
        borderWidth: "none large none none",
        borderColor: "transparent",
        css: this.stimulusHoverCss(),
        as: "div"
      }, jsx(View, {
        margin: "auto auto x-small x-small",
        padding: "auto auto auto x-small",
        as: "div"
      }, jsx(Text, {
        size: "x-small",
        color: "secondary"
      }, this.infoHeaderLabel())), jsx(View, {
        margin: "auto auto auto small",
        as: "div"
      }, jsx(Flex, {
        justifyItems: "space-between"
      }, jsx(Flex.Item, null, this.renderButton()), jsx(Flex.Item, {
        shouldGrow: true,
        shouldShrink: true,
        onClick: this.scrollToItem,
        tabIndex: "-1"
      }, jsx(Title, {
        title: stimulus.title
      })), jsx(Flex.Item, null, children)), this.renderSummary())), this.renderCollection());
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.sidebarOpen ? this.renderOpen() : this.renderClosed();
    }
  }]);
}(Component), _defineProperty(_SidebarStimulus, "displayName", 'SidebarStimulus'), _defineProperty(_SidebarStimulus, "componentId", "Quizzes".concat(_SidebarStimulus.displayName)), _defineProperty(_SidebarStimulus, "propTypes", {
  childEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  // Passed in by Sidebar
  children: PropTypes.element,
  displayPosition: PropTypes.number.isRequired,
  /* This is used for when the stimulus is being dragged in build */
  isDragging: PropTypes.bool,
  isOver: PropTypes.bool,
  isShowingItems: PropTypes.bool,
  renderSidebarItem: PropTypes.func.isRequired,
  scrollToItem: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  stimulus: ImmutablePropTypes.record.isRequired,
  stimulusParent: ImmutablePropTypes.record.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_SidebarStimulus, "defaultProps", {
  children: null,
  isDragging: false,
  isOver: false,
  isShowingItems: false
}), _SidebarStimulus)) || _class);
export default SidebarStimulus;